import "../../../../styles/page/shoppingCart.scss";
import "../../../../styles/editListCartComponent.scss";

import Icon, { iconColor, iconTypes } from "../../../common/components/Icon.jsx";
import { ProductClaimListHeader, ProductClaimListItem } from "./ProductClaimListItem.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";


import ClaimAttachmentsModal from "./ClaimAttachmentsModal.jsx";
import EmptyEditListCart from "../order/EmptyEditListCart";
import LabelField from "../../../common/components/LabelField.jsx";
import Loading from "../../../common/components/Loading.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll";
import TextField from "../../../common/components/TextField";
import YesNoModal from "../../../common/components/YesNoModal";
import { getPropertyValue } from "../../../common/util/changeUtils.jsx";
import { scssVariables } from "../../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class ClaimCart extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            expanded: this.props.deviceType!=="xs",
            confirmDisabled : false,
        };

        this.getDropDownDateStyle = this.getDropDownDateStyle.bind(this);

        this.calculateListHeight = this.calculateListHeight.bind(this);
        this.closeClaimModal = this.closeClaimModal.bind(this);
        this.onClearClaim = this.onClearClaim.bind(this);
        this.onClickClearClaim = this.onClickClearClaim.bind(this);
        this.onClickAttachments = this.onClickAttachments.bind(this);
        this.onClickExpand = this.onClickExpand.bind(this);
        this.onClickMinimize = this.onClickMinimize.bind(this);
        this.prepareShoppingCart = this.prepareShoppingCart.bind(this);
        this.commitInvoiceClaim = this.commitInvoiceClaim.bind(this);
    }

    getDropDownDateStyle() {
        const {
            width,
            deviceType,
        } = this.props;
        const {
            expanded,
        } = this.state;

        //calender max current max size is 450
        return (deviceType==="xs" && {
            width: `${Math.min(450, Math.max(parseInt(scssVariables.minDeviceWidth),width))}px`,
            top: expanded?undefined:"-381px",
        }) || (deviceType==="sm" && {
            width: `${Math.min(450,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin)+parseInt(scssVariables.menuHeight))}px`,
            left: `-${Math.min(390,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin))}px`,
        } || {
            width: "450px",
            left: "-390px"//450-subMenuItemWidth
        });
    }

    onClickClearClaim() {
        const {
            localization,
            setModal,
        } = this.props;
        setModal(<YesNoModal
            localization={localization}
            onYes={this.onClearClaim}
            onNo={this.closeClaimModal}
            onCancel={this.closeClaimModal}
            onCloseModal={this.closeClaimModal}
            labelHeader={localization.text("history","areYouSure")}
            label={localization.text("history","doYouReallyWantToClearClaim",)}
        />);
    }
    closeClaimModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }
    onClearClaim(event){
        event.stopPropagation();
        event.preventDefault();

        this.props.clearClaim();
        this.props.setModal(null);
    }
    onClickExpand() {
        this.setState({
            expanded: true,
        });
    }
    onClickMinimize() {
        this.setState({
            expanded: false,
        });
    }

    calculateListHeight() {
        const {
            height,
            deviceType,
        } = this.props;

        let listHeight = height;

        //top menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //progressbar
        listHeight -= parseInt(scssVariables.progresbarHeight);
        //second menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //bottom section
        if( deviceType==="xs" ){
            listHeight -= parseInt(scssVariables["xsClaimCartDetailHeight"]);
        } else {
            listHeight -= parseInt(scssVariables["claimCartDetailHeight"]);
        }

        return listHeight;
    }

    commitInvoiceClaim()
    {
        if (this.state.confirmDisabled) {
            return;
        }
        this.setState({confirmDisabled: true});
        this.props.commitInvoiceClaim();    
    }

    prepareShoppingCart() {
        const {
            deviceType,
            localization,
            addRemoveSalesUnitToClaim,
            addRemoveWarehouseUnitToClaim,
            editingList,
            setModal,
            setDropDown,
            editClaimItem,
        } = this.props;

        //shopping cart exist only in 2 sizes 320px($shopping-cart-width-tiny) or 465px($shopping-cart-width)
        const renderedForDeviceType = (deviceType==="xs" || deviceType==="sm") ? "xs" : "sm";

        const lines = getPropertyValue(editingList,"lines");

        const retNodes = [];
        retNodes.push(
            lines && lines.map((item) => (
                <ProductClaimListItem
                    key={`Un-${item.product.productId}`}
                    localization={localization}
                    product={item.product ||{}}
                    claimItem={item}
                    deviceType={renderedForDeviceType}
                    addRemoveSalesUnitToClaim={addRemoveSalesUnitToClaim}
                    addRemoveWarehouseUnitToClaim={addRemoveWarehouseUnitToClaim}
                    list={editingList}
                    border={false}
                    countOnylOrdered={false}
                    setModal={setModal}
                    editClaimItem={editClaimItem}
                    setDropDown={setDropDown}
                />
            ))
        );

        return retNodes;
    }

    onClickAttachments() {
        const {
            localization,
            setModal,
            editClaim,
            editingList,
        } = this.props;
        setModal(<ClaimAttachmentsModal
            localization={localization}
            onCancel={this.closeClaimModal}
            onCloseModal={this.closeClaimModal}
            editClaim ={editClaim}
            claim = {editingList}
            setModal ={setModal}
        />);
    }

    render(){
        const {
            editingList,
            editClaim,
            localization,
            height,
            deviceType,
            productLists,
        } = this.props;
        const {
            expanded,
            confirmDisabled
        } = this.state;

        const listHeight = this.calculateListHeight();

        const isTinyDevice = deviceType==="xs" || deviceType==="sm";

        const list = getPropertyValue(editingList,"lines");
        const listSize = list && list.length || 0;

        const isConfirming =  productLists.customListUploading;

        //nothing can be loading or committing, and reason code must be selected, and what will be done with the goods
        const canSave = productLists.customListsLoading===false 
        //&& productLists.customListUploading==false 
        && !confirmDisabled
        && !isConfirming && listSize>0 && editingList && editingList.committing===false 
        && editingList.lines.findIndex((item) => item.reasonCode==null || (item.claimQtyWarehouseUnits===0 && item.claimQtySalesUnits===0))===-1;
       
        const renderMenu = () => {
            return (<SubMenu>
                <SubMenuItem interactive={false} roundCornerTopLeft={true} iconType={iconTypes.listInvoice} dropDownStyle={this.getDropDownDateStyle()} />
                <SubMenuItem side="left-borderless" interactive={false}>
                    <div className="flex-align-center" style={{height:"100%", paddingLeft:"8px"}}>
                        <div className="cart-menu-header">
                            {localization.text("history","clam")}
                        </div>
                    </div>
                </SubMenuItem>
                {deviceType==="xs" && (
                    <button className="btn inmenu" onClick={this.onClickAttachments} disabled={listSize==0}>
                        <Icon type={iconTypes.upload} color={iconColor.red} />                        
                        { editingList.attachments.length>0 && (
                            <div style={{marginLeft:"15px"}}>
                                {editingList.attachments.length}
                            </div>
                        )}                                               
                    </button>
                )}
                {deviceType==="xs" && (
                    <SubMenuItem side="locked-right" onClick={expanded?this.onClickMinimize:this.onClickExpand} iconType={expanded?iconTypes.down:iconTypes.up} />
                )}
            </SubMenu>);
        };

        const renderCart = () => {
            return (
                <React.Fragment>
                    {renderMenu()}                   
                    {listSize>0? (
                        <React.Fragment>
                            <div className={"product-view-header-wrapper"} >
                                <ProductClaimListHeader localization={localization} deviceType={isTinyDevice?"xs":"sm"}/>
                            </div>
                            <Scroll className={"shopping-cart-list-wrapper"} style={{height:`${listHeight+34}px`}}>
                                {this.prepareShoppingCart()}
                            </Scroll>
                        </React.Fragment>
                    ) : (
                        productLists.customListsLoading ? (
                            <Loading height={listHeight} width="100%" loadingSize={30} points={12} lapTime={2}/>
                        ) : (
                            <EmptyEditListCart listHeight={listHeight} localization={localization}/>
                        )
                    )}
                    <div className="claim-cart-bottom" style={{height: scssVariables[deviceType==="xs"?"xsClaimCartDetailHeight":"claimCartDetailHeight"]}}>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12}>
                                <div style={{paddingBottom:"12px"}}>
                                    <LabelField label={localization.text("history","claimDescription")} />
                                    <TextField source={editingList} property="description" onEdit={editClaim} placeholder={localization.text("history","tobaccoCommentPlaceholder")} maxLength={255}/>
                                </div>
                            </ResponsiveColumn>
                            {!isTinyDevice && (
                                <ResponsiveColumn xs={12} md={6}>
                                    <button className="btn block icon" onClick={this.onClickAttachments} disabled={listSize==0}>
                                        <Icon type={iconTypes.upload} color={iconColor.red} />
                                        {localization.text("history", "attachments")} { editingList.attachments.length>0 && (`(${editingList.attachments.length})`)}
                                    </button>
                                </ResponsiveColumn>
                            )}                            
                            <ResponsiveColumn xs={12} md={6}>
                                <button className="btn block icon" onClick={this.onClickClearClaim} disabled={listSize==0}>
                                    <Icon type={iconTypes.x} color={iconColor.red} />
                                    {localization.text("history", "clearClaim")}
                                </button>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} md={6}>
                                <button className="btn block primary" onClick={this.commitInvoiceClaim}  disabled={!canSave}>
                                    {isConfirming ? localization.text("history", "submitingClaim") : localization.text("history", "submitClaim")}
                                </button>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </React.Fragment>
            );
        };

        return expanded ? (
            deviceType==="xs" ? (
                <React.Fragment>
                    <div className="dim-screen" onClick={this.onClickMinimize}/>
                    <div className="shopping-cart-card-expanded-tiny" style={{height:`${height+parseInt(scssVariables.cardMargin)}px`}}>
                        {renderCart()}
                    </div>
                </React.Fragment>
            ) : (
                <div className="card-default shopping-cart-card" style={{height:`${height}px`}}>
                    {renderCart()}
                </div>
            )
        ) : (
            <div className="shopping-cart-card-tiny">
                {renderMenu()}
            </div>
        );
    }
}

ClaimCart.propTypes = {
    localization: Localization.propTypes.isRequired,
    addRemoveSalesUnitToClaim: PropTypes.func.isRequired,
    addRemoveWarehouseUnitToClaim: PropTypes.func.isRequired,
    editClaim: PropTypes.func.isRequired,
    editClaimItem: PropTypes.func.isRequired,
    clearClaim: PropTypes.func.isRequired,
    editingList: PropTypes.object.isRequired,
    productLists: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number,
    deliveryDates: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    commitInvoiceClaim: PropTypes.func.isRequired,
    //
    listId: PropTypes.number,
};

export default withRouter(ClaimCart);